import { render, staticRenderFns } from "./fortune.vue?vue&type=template&id=aec39622&scoped=true&"
import script from "./fortune.vue?vue&type=script&lang=js&"
export * from "./fortune.vue?vue&type=script&lang=js&"
import style0 from "./fortune.vue?vue&type=style&index=0&id=aec39622&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec39622",
  null
  
)

export default component.exports